import {
  APP_SPECIALITY_CENTRE_REQUEST,
  APP_SPECIALITY_CENTRE_RESPONSE,
  APP_SPECIALITY_CENTRE_FAILURE,
  APP_SPECIALITY_CENTRE_UPDATE_FILTERS
} from "../../../actions/types";

const initialState = {
  isFetching: false,
  error: false,
  results: [],
  total: 0,
  filters: {
    from: 0,
    size: 25,
    activePage: 1,
    sorting: { key: "LAYER_IV_ACCOUNT_NAME", order: "asc" },
    queryText: "",
  },
};

const setRequest = (state, action) => {
  let { filters } = action.payload;
  filters = filters || {};

  return {
    ...state,
    isFetching: true,
    error: false,
    results: [],
    filters,
    total: 0,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    total: 0,
  };
};

const setResponse = (state, action) => {
  let { results = [], total = 0 } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    total,
  };
};

const updateFilterState = (state, action) => {
  let { filters = {} } = action.payload;
  filters = filters || {};

  return {
    ...state,
    filters,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_SPECIALITY_CENTRE_REQUEST:
      return setRequest(state, action);

    case APP_SPECIALITY_CENTRE_RESPONSE:
      return setResponse(state, action);

    case APP_SPECIALITY_CENTRE_FAILURE:
      return setFailure(state, action);

    case APP_SPECIALITY_CENTRE_UPDATE_FILTERS:
      return updateFilterState(state, action);

    default:
      return state;
  }
};
